<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M990 1194 l0 -46 -62 7 c-35 4 -204 9 -377 11 -284 4 -316 3 -332
-12 -23 -20 -24 -53 -5 -80 13 -17 31 -20 153 -25 l138 -5 -166 -2 c-151 -2
-168 -4 -184 -22 -18 -20 -15 -70 5 -70 6 0 10 -4 10 -10 0 -5 -11 -10 -23
-10 -28 0 -57 -29 -57 -57 0 -28 34 -56 70 -57 32 -1 39 -10 15 -20 -8 -3 -20
-17 -27 -30 -18 -40 10 -74 64 -78 l43 -3 3 -62 3 -63 -43 0 c-24 0 -54 -7
-66 -16 -22 -15 -22 -19 -22 -244 0 -281 -14 -260 172 -260 180 0 168 -19 168
264 0 221 0 225 -22 240 -12 9 -42 16 -65 16 l-43 0 0 65 0 65 155 0 c85 0
155 -3 155 -7 0 -5 -21 -42 -45 -83 -25 -41 -45 -80 -45 -87 0 -20 46 -63 66
-63 16 0 60 41 152 142 23 26 58 55 78 64 38 18 78 71 89 117 9 33 45 39 45 7
0 -19 7 -20 100 -20 l100 0 -2 238 -3 237 -97 3 -98 3 0 -47z m180 -194 l0
-220 -82 0 -83 0 2 187 c2 104 3 203 3 221 l0 32 80 0 80 0 0 -220z m-282 127
c31 -30 52 -90 52 -147 0 -20 4 -29 11 -24 14 8 3 96 -17 135 -19 38 -19 39
21 39 l35 0 0 -155 0 -155 -25 0 c-20 0 -26 -7 -35 -40 -13 -48 -58 -103 -99
-119 -15 -7 -63 -52 -106 -102 -43 -49 -84 -89 -92 -89 -26 0 -53 20 -53 40 0
11 23 57 51 101 33 53 47 85 41 91 -5 5 -42 8 -81 6 l-70 -3 5 36 c5 29 1 41
-19 62 l-24 27 -170 0 c-184 0 -208 6 -201 51 l3 24 185 5 c166 4 185 7 188
23 3 16 -9 17 -150 17 -159 0 -178 5 -178 42 0 31 35 38 200 38 148 0 161 1
158 18 -3 15 -19 17 -137 20 -140 3 -161 9 -161 46 0 46 6 47 332 44 l307 -3
29 -28z m-503 -357 c-18 -20 -18 -21 1 -35 10 -8 25 -15 32 -15 6 0 12 -5 12
-11 0 -6 -7 -8 -16 -5 -9 3 -29 6 -45 6 -22 0 -29 5 -29 20 0 17 -7 20 -39 20
-33 0 -40 -4 -43 -22 -2 -13 -6 -22 -10 -20 -5 1 -23 2 -42 2 -39 0 -55 25
-36 60 10 18 20 20 122 20 111 0 111 0 93 -20z m120 -15 c0 -25 -4 -31 -27
-33 -15 -2 -41 4 -59 13 l-32 17 29 19 c17 11 42 18 59 17 26 -3 30 -7 30 -33z
m-185 -111 c0 -80 -1 -85 -20 -82 -19 3 -21 12 -24 86 -4 81 -3 82 20 82 23 0
24 -2 24 -86z m128 -201 l3 -93 -153 0 -153 0 2 80 c0 45 4 88 7 96 5 12 30
14 148 12 l143 -3 3 -92z m2 -198 l0 -86 -151 3 -151 3 0 78 c1 42 1 79 2 82
0 3 68 5 150 5 l150 0 0 -85z m0 -128 c0 -18 -5 -38 -12 -45 -13 -13 -254 -17
-274 -4 -10 6 -19 49 -15 75 1 4 69 7 151 7 l150 0 0 -33z"
      />
      <path
        d="M1045 1185 c-14 -13 -25 -31 -25 -40 0 -20 44 -65 63 -65 25 0 67 41
67 64 0 26 -38 66 -64 66 -9 0 -28 -11 -41 -25z m73 -7 c7 -7 12 -21 12 -33 0
-47 -62 -63 -81 -21 -22 47 33 90 69 54z"
      />
      <path
        d="M577 1043 c-11 -10 -8 -181 3 -188 6 -4 10 30 10 94 0 101 -1 107
-13 94z"
      />
      <path
        d="M751 892 c-38 -19 -79 -67 -67 -79 4 -4 12 0 17 10 32 56 80 75 151
60 54 -11 65 -1 17 16 -45 16 -79 14 -118 -7z"
      />
      <path
        d="M190 440 l0 -60 110 0 110 0 0 60 0 60 -110 0 -110 0 0 -60z m208 3
l3 -43 -100 0 -101 0 0 45 0 46 98 -3 97 -3 3 -42z"
      />
      <path
        d="M214 275 c-16 -13 -17 -16 -4 -25 13 -8 13 -11 1 -19 -16 -10 -8 -41
10 -41 8 0 9 4 0 13 -13 16 -5 27 21 27 10 0 18 -7 18 -15 0 -8 -5 -15 -12
-15 -6 0 -8 -3 -5 -6 4 -4 13 -1 22 6 11 9 12 16 5 25 -6 7 -7 20 -4 30 4 10
1 21 -7 26 -19 12 -22 11 -45 -6z m42 -6 c8 -14 -18 -31 -30 -19 -9 9 0 30 14
30 5 0 12 -5 16 -11z"
      />
      <path
        d="M340 260 c0 -13 7 -20 20 -20 11 0 20 -4 20 -10 0 -5 1 -13 2 -17 1
-5 -11 -11 -28 -14 -27 -6 -27 -7 -4 -8 14 0 31 3 39 8 18 12 6 41 -20 48 -12
3 -18 11 -15 19 3 8 1 14 -4 14 -6 0 -10 -9 -10 -20z"
      />
      <path
        d="M860 220 l0 -160 40 0 39 0 3 82 3 81 31 -26 c18 -15 35 -27 39 -27
4 0 21 12 39 27 l31 26 3 -81 3 -82 39 0 40 0 0 160 c0 88 -4 160 -8 160 -4 0
-38 -25 -75 -55 -36 -30 -69 -55 -72 -55 -3 0 -36 25 -72 55 -37 30 -71 55
-75 55 -4 0 -8 -72 -8 -160z m92 70 c33 -28 65 -47 71 -43 7 4 35 26 63 50 28
24 54 43 58 43 3 0 6 -58 6 -130 0 -123 -1 -130 -20 -130 -19 0 -20 7 -20 90
0 50 -3 90 -6 90 -3 0 -23 -13 -44 -30 -21 -16 -41 -30 -45 -30 -4 0 -24 14
-45 30 -21 17 -41 30 -44 30 -3 0 -6 -40 -6 -90 0 -83 -1 -90 -20 -90 -19 0
-20 7 -20 130 0 72 3 130 6 130 3 0 33 -23 66 -50z"
      />
      <path
        d="M550 214 l0 -156 90 4 c70 3 96 9 118 24 43 32 64 81 59 142 -7 100
-64 142 -189 142 l-78 0 0 -156z m195 114 c56 -44 71 -131 32 -189 -31 -46
-61 -59 -139 -59 l-68 0 0 135 0 135 74 0 c60 0 78 -4 101 -22z"
      />
      <path
        d="M610 215 l0 -95 49 0 c64 0 79 6 96 41 24 45 19 87 -14 120 -25 24
-37 29 -80 29 l-51 0 0 -95z m118 50 c49 -57 6 -135 -73 -135 -25 0 -25 1 -25
86 l0 87 38 -6 c22 -4 46 -17 60 -32z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
